import React from "react";

export const ProfileContext = React.createContext({
    Profile: {},
    setProfile: (Profile: {}) => {}
});

export default ProfileContext